module.exports = __webpack_public_path__ + "static/media/journals-v2.a3d36658.svg";